import {
  useQuery,
  useMutation,
  UseQueryOptions,
  UseQueryResult,
  UseMutationResult,
} from '@tanstack/react-query';
import { ViewFiltersAPI } from 'api/view-filters';
import { ViewTransformer } from 'api/view-filters/transformer';
import { ViewType } from 'api/view-filters/types';
import { queryClient } from 'queries';
import { Views } from 'components/molecules/saved-views/types';
import { ApiViewDefinition, ViewDefinition } from './types';

const VIEW_FILTERS_QUERY_KEY = ['all-signals', 'views'];

export type ViewFiltersQueryKeyType = [string, string];

export const useGetViewFiltersQuery = <
  T = ApiViewDefinition,
  V = ViewDefinition,
>(
  viewTransformer: ViewTransformer<T, V>,
  viewType: ViewType,
  queryKey: ViewFiltersQueryKeyType,
  queryOptions: UseQueryOptions<
    Views<V>,
    unknown,
    Views<V>,
    ViewFiltersQueryKeyType
  >,
): UseQueryResult<any, unknown> => {
  return useQuery({
    ...queryOptions,
    queryKey,
    // queryFn: () =>
    //   ViewFiltersAPI.getAllViews<T>(viewType).then((data) =>
    //     load(data.map(viewTransformer.from)),
    //   ),
    queryFn: () => ViewFiltersAPI.getViewFilters(),
    staleTime: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export const useSaveViewFilterMutation = (): UseMutationResult<
  any,
  unknown,
  any
> => {
  return useMutation({
    mutationFn: (payload: any): Promise<any> => {
      return ViewFiltersAPI.saveViewFilter(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VIEW_FILTERS_QUERY_KEY });
    },
  });
};

export const useUpdateViewFilterMutation = (): UseMutationResult<
  any,
  unknown,
  any
> => {
  return useMutation({
    mutationFn: (payload: any): Promise<any> => {
      return ViewFiltersAPI.updateViewFilter(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VIEW_FILTERS_QUERY_KEY });
    },
  });
};
